import { useQuery } from '@tanstack/react-query';
import { API } from '~/shared/API/api';
import { useUserCardsStore } from '../store/userCardsStore';
import { useEffect } from 'react';

export const useGetCards = () => {
  const { state, actions } = useUserCardsStore();
  const { data, isLoading, refetch, isSuccess } = useQuery({
    queryKey: ['cards'],
    queryFn: () => API.getCards(),
    // retry: 1,
    select: (data) => data.data.payload,
    refetchOnWindowFocus: 'always',
  });

  useEffect(() => {
    if (isLoading) {
      actions.setUserCards({ loading: true, cards: state.cards });
    }
  }, [isLoading]);

  useEffect(() => {
    if (isSuccess) {
      actions.setUserCards({ loading: false, cards: data });
    }
  }, [isSuccess]);

  return { cards: data, isLoading, refetch, isSuccess };
};
